module.exports = __webpack_public_path__ + "img/4-3.29d39e13.svg";